import { useEffect, useState } from 'react';
import { onSnapshot, collection, query, orderBy } from 'firebase/firestore';
import { db } from '../../../firebase';
import type { Inquiry } from '../../../services/inquiryService';

export const useInquiries = () => {
  const [inquiries, setInquiries] = useState<Inquiry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const q = query(collection(db, 'inquiries'), orderBy('created_at', 'desc'));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        try {
          const items = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          })) as Inquiry[];
          setInquiries(items);
          setLoading(false);
          setError(null);
        } catch (err) {
          console.error('문의 데이터 파싱 오류:', err);
          setError('문의 데이터 처리 중 오류가 발생했습니다.');
          setLoading(false);
        }
      },
      (err) => {
        console.error('문의 구독 오류:', err);
        setError('문의 데이터 연결에 실패했습니다.');
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, []);

  const pendingCount = inquiries.filter((i) => i.status === 'pending').length;

  return { inquiries, pendingCount, loading, error };
};
